// Create a new file: src/components/AdminRoute.js

import React from 'react';
import { useProfile } from '../context/ProfileContext';
import { Navigate } from 'react-router-dom';
import toast from 'react-hot-toast';

const AdminRoute = ({ children }) => {
    const { user, initialising, isAdmin } = useProfile();

    if (initialising) {
        // Show a loading spinner or a blank page while the user profile and claims are loading
        return <div>Loading...</div>; 
    }

    if (!user || !isAdmin) {
        // If the user is not logged in or is not an admin, redirect them.
        toast.error("You do not have permission to access this page.");
        return <Navigate to="/" replace />;
    }

    // If the user is an admin, render the child component (the AdminPage).
    return children;
};

export default AdminRoute;